import { render, staticRenderFns } from "./PropertyCalendarSidebarItem.vue?vue&type=template&id=67d48b72&scoped=true&"
import script from "./PropertyCalendarSidebarItem.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d48b72",
  null
  
)

export default component.exports